/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { observable, action } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI
//----------------------------------------------------------------------//

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
import CollectionDetails from '../../components/CollectionDetails/CollectionDetails';
import DetailsPanel from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel';
import styles from './AssetCalibrationRequest.module.scss';

//----------------------------------------------------------------------//
// UTILS
//----------------------------------------------------------------------//

@translate()
export default class AssetCalibrationRequest extends React.Component<*> {
  render(): React.Element<*> {
    const { t, data } = this.props;
    const asset = data.details.contract.assets[0];

    return (
      <React.Fragment>
        <DetailsPanel data={data} assetTitle={t('general:assets.labels.details')} />

        <CollectionDetails asset={asset} />

        <div className={styles['list-container']}>
          <b>{t('general:labels.additional_info')}</b>
          <ul>
            <li>
              {t('general:labels.replacement_asset_required')}: {asset.replacement_required}
            </li>
            <li>
              {t('general:assets.reasons.original_packaging')}: {asset.keep_original_packaging}
            </li>
            <li>
              {t('general:labels.packaging_details')}: {asset.packaging_description}
            </li>
          </ul>
        </div>
      </React.Fragment>
    );
  }
}
